import cn from 'classnames';

import { IconLoader } from 'components/UI/Icons/Loader';

export interface PrefixSuffixWrapper {
  className?: string;
  disabled?: boolean;
  item?: JSX.Element | string;
  loading?: boolean;
  onClick?: JSX.IntrinsicElements['button']['onClick'];
  tagName?: JSX.ElementType;
}

export const PrefixSuffixWrapper = ({
  className,
  disabled = false,
  item,
  loading = false,
  onClick,
  tagName,
}: PrefixSuffixWrapper) => {
  const Tag = tagName ?? 'div';
  if (typeof item === 'string') {
    return (
      <div
        className={cn(
          'flex h-6 flex-shrink-0 items-center rounded-full bg-gray-300 px-2 text-12/100% font-medium',
          {
            'group-focus-within:bg-transparent': !disabled,
            'text-gray-500': disabled,
            'text-gray-700': !disabled,
          },
          className,
        )}
      >
        {item}
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex h-6 w-6 flex-shrink-0 justify-center rounded-full bg-gray-300',
        !disabled && 'group-focus-within:bg-transparent',
      )}
    >
      {loading ? (
        <div
          className={cn(
            'flex items-center text-gray-800 [&>svg]:h-4 [&>svg]:w-4 [&>svg]:animate-spin',
            className,
          )}
        >
          <IconLoader />
        </div>
      ) : (
        <Tag
          className={cn(
            'flex h-3.5 w-3.5',
            {
              'text-gray-500': disabled,
              'text-gray-600': !disabled,
            },
            className,
          )}
          {...(tagName === 'button' ? { onClick } : {})}
        >
          {item}
        </Tag>
      )}
    </div>
  );
};
